import React from 'react';
import { FlexContainerRowInner } from '../styled/skylab/page';
import FormInput from '../../containers/shared/forms/form-input';
import FormSelect from '../../containers/shared/forms/form-select';
import PasswordInput from './password-input';
import { useFetchRegionsAndCountries } from './hooks';
const CreateAccountForm = ({ isObapiSignup = false }) => {
    const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries();
    return (React.createElement("form", { className: 'pad-all-xs' },
        React.createElement(FlexContainerRowInner, null,
            React.createElement("fieldset", null,
                React.createElement(FormInput, { fieldName: 'firstName', placeholder: 'First Name' })),
            React.createElement("fieldset", null,
                React.createElement(FormInput, { fieldName: 'lastName', placeholder: 'Last Name' }))),
        React.createElement("fieldset", null,
            React.createElement(FormInput, { fieldName: 'companyName', placeholder: 'Company Name' })),
        React.createElement("fieldset", null,
            React.createElement(FormInput, { fieldName: 'street1', placeholder: 'Primary business address' })),
        React.createElement("fieldset", null,
            React.createElement(FormInput, { fieldName: 'city', placeholder: 'City' })),
        React.createElement(FlexContainerRowInner, null,
            React.createElement("fieldset", null,
                React.createElement(FormSelect, { fieldName: 'state', fieldValues: formattedRegions })),
            React.createElement("fieldset", null,
                React.createElement(FormInput, { fieldName: 'postalCode', placeholder: 'Zip/Postal code' }))),
        React.createElement("fieldset", null,
            React.createElement(FormSelect, { fieldName: 'country', fieldValues: formattedCountries })),
        React.createElement("fieldset", null,
            React.createElement(FormInput, { fieldName: 'phone', placeholder: 'Phone' })),
        React.createElement("fieldset", null,
            React.createElement(FormInput, { fieldName: 'email', placeholder: 'Email/username', type: 'email' })),
        isObapiSignup && React.createElement(PasswordInput, null)));
};
export default CreateAccountForm;
